import { Check } from 'lucide-react';
import { Avatar } from '../../../../design-system/avatar/avatar/avatar';
import { Button } from '../../../../design-system/button/button';
import { Inline } from '../../../../design-system/inline/inline';
import { Stack } from '../../../../design-system/stack/stack';

type SuccessStepProps = {
  from: { name: string; imageUrl?: string };
  to: { name: string; imageUrl?: string };
  amount: string;
  isInstantTransfer?: boolean;
  onDone: () => void;
};

export const SuccessStep = ({ from, to, amount, isInstantTransfer, onDone }: SuccessStepProps) => {
  return (
    <Stack align="stretch" space={16} className="w-full rounded-lg bg-white p-8">
      <Stack space={3} align="center">
        <Inline justify="center" className="h-20 w-20 rounded-full border border-primary bg-white p-4">
          <Check size={30} />
        </Inline>

        <Stack space={2} align="center">
          <p className="text-xl font-medium text-black">Transfer successful</p>

          <p className="text-center text-base leading-6 font-medium tracking-tight text-muted-foreground">
            {isInstantTransfer
              ? "We've moved the money between your two accounts."
              : 'Most transfers complete instantly, but some may take a little longer depending on your bank.'}
          </p>
        </Stack>
      </Stack>

      <Stack space={6} align="stretch">
        <Stack space={3} align="stretch">
          <Inline justify="between">
            <p className="text-base font-medium text-muted-foreground">From</p>
            <Inline space={2}>
              {from.imageUrl && <Avatar avatarUrl={from.imageUrl} name={from.name} className="h-5 w-5" />}
              <p className="text-base font-medium text-black">{from.name}</p>
            </Inline>
          </Inline>

          <Inline justify="between">
            <p className="text-base font-medium text-muted-foreground">To</p>
            <Inline space={2}>
              {to.imageUrl && <Avatar avatarUrl={to.imageUrl} name={to.name} className="h-5 w-5" />}
              <p className="text-base font-medium text-black">{to.name}</p>
            </Inline>
          </Inline>

          <Inline justify="between">
            <p className="text-base font-medium text-muted-foreground">Amount</p>

            <p className="text-base font-medium text-black">{amount}</p>
          </Inline>
        </Stack>

        <Stack space={3} align="stretch">
          <Button variant="secondary" onClick={onDone}>
            Done
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
};
